import H4 from "../../../components/global/H4";
import { css } from "emotion";
import ColorServices from "../../../services/ColorServices";

const wrapper = css({
  margin: "0 -8px -8px -8px",
  ">h4": {
    textAlign: "center",
    marginBottom: 32
  }
});

const flex = css({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap"
});

const child = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: ColorServices.getColor("purpleMid"),
  maxWidth: 160,
  minHeight: 160,
  width: "100%",
  borderRadius: 8,
  margin: 8,
  img: {
    maxWidth: 158,
    maxHeight: 42,
    marginBottom: 8
  },
  h4: {
    color: "white"
  }
});

const WorldClassFeatures = ({ topicsObj }) => {
  return (
    <div className={wrapper}>
      <H4>See world class features for:</H4>
      <div className={flex}>
        {topicsObj.map(topic => (
          <div className={child}>
            <img src={topic.img} alt={topic.alt} />
            <H4>{topic.text}</H4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorldClassFeatures;
